<div [formGroup]="form">
    <div
        class="btn-group btn-group-toggle"
        [formControlName]="'periodType'"
        ngbRadioGroup
    >
        <ng-container *ngFor="let i of periodTypeOpts">
            <label
                class="btn btn-primary"
                ngbButtonLabel
            >
                <input
                    type="radio"
                    [value]="i.value"
                    ngbButton
                />
                {{ i.tlKey | translate }}
            </label>
        </ng-container>
    </div>

    <div
        class="mt-3"
        *ngIf="cacheDates"
    >
        <label
            class="mr-3 mb-0"
            id="insightDateRange"
            >{{ i18n._709_DATE_RANGE | translate }}</label
        >
        <div class="d-inline-block">
            <div
                class="input-group"
                [hidden]="periodType !== PeriodType.DAY"
            >
                <input
                    class="form-control"
                    [placeholder]="i18n._646_YYYY_MM_DD | translate"
                    aria-labelledby="insightDateRange"
                    ngbDatepicker
                    [markDisabled]="invalidEventDate"
                    [formControlName]="'eventDateDay'"
                    #dp="ngbDatepicker"
                />
                <div class="input-group-append">
                    <button
                        type="button"
                        class="btn btn-secondary cmps-cdk-py-0dot5"
                        aria-label="Toggle date picker"
                        [attr.aria-expanded]="dp.isOpen()"
                        (click)="dp.toggle()"
                    >
                        <cmps-icon svgIcon="calendar"></cmps-icon>
                    </button>
                </div>
            </div>
            <ng-select
                [hidden]="periodType === PeriodType.DAY"
                [options]="eventDateOpts"
                [placeholder]="'&nbsp;'"
                [ariaLabelledBy]="'insightDateRange'"
                [formControlName]="'eventDate'"
            ></ng-select>
        </div>
    </div>
</div>
